export const modals = {
  VIDEO_PROCESS_MODAL: "VIDEO_PROCESS_MODAL",
};
